import { baseApi } from "./baseApi";

// FormQuestions API
export const formQuestionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getFormQuestions: builder.query({
      query: (params) => {
        let url = "form_questions";
        url += "?";

        if (params?.page || params?.include_all) {

          if (params.page) {
            url += `page=${params.page}&`;
          }
          if (params.include_all) {
            url += `include_all=${params.include_all}&`;
          }

        }

        if (params.section_id) {
          url += `section_id=${params.section_id}&`;
        }

        // Remove the trailing '&' if any
        url = url.slice(0, -1);

        return url;
      }
    }),
    createFormQuestion: builder.mutation({
      query: (formQuestion) => ({
        url: "form_questions",
        method: "POST",
        body: formQuestion
      })
    }),
    updateFormQuestion: builder.mutation({
      query: (params) => ({
        url: `form_questions/${params.id}`,
        method: "PUT",
        body: params.formQuestion
      })
    }),
    getFormQuestion: builder.query({
      query: (id) => `form_questions/${id}`
    }),
  })
});

// Export mutations and queries
export const {
  useGetFormQuestionsQuery,
  useCreateFormQuestionMutation,
  useUpdateFormQuestionMutation,
  useGetFormQuestionQuery
} = formQuestionApi;
